
import { Drug, CalendarEvent, LabEntry, User, RotationWeek, EducationEvent, Inpatient, OnCallCaseLog } from './types';

export const USERS: User[] = [
  { id: '1', lastName: 'Aeschlimann', firstName: 'Kim', role: 'Attending' },
  { id: '2', lastName: 'Allen', firstName: 'Dave', role: 'Attending' },
  { id: '3', lastName: 'Wilson', firstName: 'Eric', role: 'Attending' },
  { id: '4', lastName: 'Friesen', firstName: 'Stacy', role: 'Attending' },
  { id: '5', lastName: 'Marquiss', firstName: 'Annie', role: 'Attending' },
  { id: '11', lastName: 'Weinstein', firstName: 'David', role: 'Attending' },
  { id: '6', lastName: 'Pyne', firstName: 'Connor', role: 'Attending' },
  { id: '7', lastName: 'Pate', firstName: 'Brandon', role: 'Resident' },
  { id: '8', lastName: 'Grisham', firstName: 'Kevin', role: 'Resident', isAdmin: true },
  { id: '9', lastName: 'Balcom', firstName: 'Jackson', role: 'Resident' },
  { id: '12', lastName: 'Bulloch', firstName: 'Resident', role: 'Resident' }
];

export const PROCEDURES_LIST = [
  // Abdominal - SA
  "Abdominal - SA - General - Abdominal exploratory with drainage technique",
  "Abdominal - SA - General - Abdominal lymph node removal",
  "Abdominal - SA - General - Adrenal biopsy",
  "Abdominal - SA - General - Adrenalectomy",
  "Abdominal - SA - General - Body wall herniorrhaphy",
  "Abdominal - SA - General - Diaphragmatic herniorrhaphy",
  "Abdominal - SA - General - Exploratory laparotomy - death / euthanasia on table",
  "Abdominal - SA - General - Exploratory laparotomy - negative explore",
  "Abdominal - SA - General - Exploratory laparotomy - unresectable mass",
  "Abdominal - SA - General - Inguinal herniorrhaphy",
  "Abdominal - SA - General - Omentalization of cyst or abscess",
  "Abdominal - SA - General - Open drainage of cyst",
  "Abdominal - SA - General - Open lymphangiography",
  "Abdominal - SA - General - Open portography",
  "Abdominal - SA - General - Partial splenectomy",
  "Abdominal - SA - General - Pericardial diaphragmatic herniorrhaphy",
  "Abdominal - SA - General - Prepubic tendon rupture repair",
  "Abdominal - SA - General - Splenectomy",
  
  // Gastrointestinal Surgery
  "Gastrointestinal Surgery - Colon/rectal - Colonic resection and anastomosis",
  "Gastrointestinal Surgery - Colon/rectal - Colopexy",
  "Gastrointestinal Surgery - Colon/rectal - Colostomy",
  "Gastrointestinal Surgery - Colon/rectal - Colotomy",
  "Gastrointestinal Surgery - Colon/rectal - Rectal pull-through",
  "Gastrointestinal Surgery - Colon/rectal - Rectal reduction/resection",
  "Gastrointestinal Surgery - Colon/rectal - Subtotal colectomy",
  "Gastrointestinal Surgery - Colon/rectal - Typhlectomy",
  "Gastrointestinal Surgery - Esophagus - Esophageal resection/anastomosis",
  "Gastrointestinal Surgery - Esophagus - Esophagotomy",
  "Gastrointestinal Surgery - Gallbladder - Bile duct stent, open placement",
  "Gastrointestinal Surgery - Gallbladder - Cholecystectomy",
  "Gastrointestinal Surgery - Gallbladder - Cholecystoduodenostomy",
  "Gastrointestinal Surgery - Gallbladder - Cholecystojejunostomy",
  "Gastrointestinal Surgery - Gallbladder - Cholecystotomy",
  "Gastrointestinal Surgery - Gallbladder - Choledochoduodenostomy",
  "Gastrointestinal Surgery - Gallbladder - Choledochotomy",
  "Gastrointestinal Surgery - General - Exploratory laparotomy",
  "Gastrointestinal Surgery - General - Multiple GI biopsies",
  "Gastrointestinal Surgery - General - Omentalization of cyst or abscess",
  "Gastrointestinal Surgery - General - Open drainage of cyst",
  "Gastrointestinal Surgery - Liver - Liver biopsy",
  "Gastrointestinal Surgery - Liver - Partial hepatectomy",
  "Gastrointestinal Surgery - Liver - Partial liver lobectomy",
  "Gastrointestinal Surgery - Liver - Portosystemic shunt ligation, ameroid constrictor",
  "Gastrointestinal Surgery - Liver - Portosystemic shunt ligation, cellophane band",
  "Gastrointestinal Surgery - Liver - Portosystemic shunt ligation, suture",
  "Gastrointestinal Surgery - Liver - Total liver lobectomy",
  "Gastrointestinal Surgery - Pancreas - Pancreatic biopsy",
  "Gastrointestinal Surgery - Pancreas - Partial pancreatectomy",
  "Gastrointestinal Surgery - Small intestine - Derotate intestines",
  "Gastrointestinal Surgery - Small intestine - Enteropexy",
  "Gastrointestinal Surgery - Small intestine - Enteroplication",
  "Gastrointestinal Surgery - Small intestine - Enterotomy",
  "Gastrointestinal Surgery - Small intestine - Intestinal biopsy",
  "Gastrointestinal Surgery - Small intestine - Intestinal resection and anastomosis",
  "Gastrointestinal Surgery - Stomach - Gastric biopsy",
  "Gastrointestinal Surgery - Stomach - Gastroduodenostomy",
  "Gastrointestinal Surgery - Stomach - Gastrojejunostomy",
  "Gastrointestinal Surgery - Stomach - Gastropexy",
  "Gastrointestinal Surgery - Stomach - Gastrotomy",
  "Gastrointestinal Surgery - Stomach - Partial gastrectomy",
  "Gastrointestinal Surgery - Stomach - Pylorectomy",
  "Gastrointestinal Surgery - Stomach - Pyloromyotomy",
  "Gastrointestinal Surgery - Stomach - Pyloroplasty",

  // Head/Neck Surgery
  "Head/Neck Surgery - Ear - Lateral bulla osteotomy",
  "Head/Neck Surgery - Ear - Lateral ear canal resection",
  "Head/Neck Surgery - Ear - Pinnectomy - complete",
  "Head/Neck Surgery - Ear - Pinnectomy - partial",
  "Head/Neck Surgery - Ear - Total ear canal ablation",
  "Head/Neck Surgery - Ear - Ventral bulla osteotomy",
  "Head/Neck Surgery - Ear - Vertical ear canal ablation",
  "Head/Neck Surgery - General - Cheiloplasty",
  "Head/Neck Surgery - General - Dorsal rhinotomy",
  "Head/Neck Surgery - General - Enucleation",
  "Head/Neck Surgery - General - Excise mass",
  "Head/Neck Surgery - General - Exenteration",
  "Head/Neck Surgery - General - Parathyroidectomy",
  "Head/Neck Surgery - General - Sialoadenectomy",
  "Head/Neck Surgery - General - Thyroidectomy",
  "Head/Neck Surgery - Mandible/maxilla - Mandibular condylectomy",
  "Head/Neck Surgery - Mandible/maxilla - Partial excision of vertical ramus",
  "Head/Neck Surgery - Mandible/maxilla - Partial mandibulectomy",
  "Head/Neck Surgery - Mandible/maxilla - Partial maxillectomy",
  "Head/Neck Surgery - Mandible/maxilla - Partial resection zygomatic arch",
  "Head/Neck Surgery - Oral - Closure hard palate defect",
  "Head/Neck Surgery - Oral - Closure soft palate defect",
  "Head/Neck Surgery - Oral - Oronasal fistula closure",
  "Head/Neck Surgery - Oral - Partial glossectomy",
  "Head/Neck Surgery - Upper airway - Bilateral arytenoid lateralization",
  "Head/Neck Surgery - Upper airway - Castellated laryngofissure",
  "Head/Neck Surgery - Upper airway - Cricopharyngeal myotomy/myectomy",
  "Head/Neck Surgery - Upper airway - Laryngeal sacculectomy",
  "Head/Neck Surgery - Upper airway - Nasal fold resection",
  "Head/Neck Surgery - Upper airway - Partial laryngectomy via oral approach",
  "Head/Neck Surgery - Upper airway - Partial laryngectomy via ventral laryngotomy",
  "Head/Neck Surgery - Upper airway - Permanent tracheostomy",
  "Head/Neck Surgery - Upper airway - Pharyngotomy",
  "Head/Neck Surgery - Upper airway - Resection dorsolateral nasal cartilages",
  "Head/Neck Surgery - Upper airway - Resection nasal planum",
  "Head/Neck Surgery - Upper airway - Staphylectomy",
  "Head/Neck Surgery - Upper airway - Tonsillectomy",
  "Head/Neck Surgery - Upper airway - Tracheal resection and anastomosis",
  "Head/Neck Surgery - Upper airway - Tracheal ring prosthesis, extraluminal only",
  "Head/Neck Surgery - Upper airway - Tracheotomy",
  "Head/Neck Surgery - Upper airway - Unilateral arytenoid lateralization",
  "Head/Neck Surgery - Upper airway - Ventral rhinotomy",
  "Head/Neck Surgery - Upper airway - Ventriculocordectomy",

  // MIS
  "MIS - Arthroscopy - Carpus/tarsus - Arthroscopy",
  "MIS - Arthroscopy - Elbow - Arthroscopy",
  "MIS - Arthroscopy - Hip - Arthroscopy",
  "MIS - Arthroscopy - Shoulder - Arthroscopy",
  "MIS - Arthroscopy - Stifle - Arthroscopy",
  "MIS - Laparoscopy - General - Exploratory arthroscopy",
  "MIS - Laparoscopy - General - Exploratory arthroscopy with biopsy",
  "MIS - Laparoscopy - General - Exploratory arthroscopy with fragment retrieval",
  "MIS - Laparoscopy - General - Meniscal release",
  "MIS - Laparoscopy - General - Meniscectomy",
  "MIS - Laparoscopy - General - Adrenalectomy",
  "MIS - Laparoscopy - General - Cholecystectomy",
  "MIS - Laparoscopy - General - Cryptorchid castration",
  "MIS - Laparoscopy - General - Cystotomy",
  "MIS - Laparoscopy - General - Exploratory laparoscopy",
  "MIS - Laparoscopy - General - Gastrointestinal biopsy",
  "MIS - Laparoscopy - General - Gastropexy",
  "MIS - Laparoscopy - General - Gastrostomy tube placement",
  "MIS - Laparoscopy - General - Jejunostomy tube placement",
  "MIS - Laparoscopy - General - Liver biopsy",
  "MIS - Laparoscopy - General - Ovariectomy",
  "MIS - Laparoscopy - General - Ovariohysterectomy",
  "MIS - Laparoscopy - General - Pancreatic biopsy",
  "MIS - Thoracoscopy - General - Exploratory thoracoscopy",
  "MIS - Thoracoscopy - General - Lung biopsy",
  "MIS - Thoracoscopy - General - Lung lobectomy",
  "MIS - Thoracoscopy - General - Lymph node biopsy",
  "MIS - Thoracoscopy - General - Mediastinal/pleural biopsy",
  "MIS - Thoracoscopy - General - Mediastinal/pleural debridement",
  "MIS - Thoracoscopy - General - Partial pericardiectomy",
  "MIS - Thoracoscopy - General - PDA ligation",
  "MIS - Thoracoscopy - General - Pericardial window",
  "MIS - Thoracoscopy - General - PRAA ligation/transection",
  "MIS - Thoracoscopy - General - Right auriculectomy",
  "MIS - Thoracoscopy - General - Subtotal pericardiectomy",
  "MIS - Thoracoscopy - General - Thoracic duct ligation",
  "MIS - Thoracoscopy - General - Thymectomy",

  // Neurologic
  "Neurologic Surgery - General - Articular facet screws",
  "Neurologic Surgery - General - Brachial plexus exploration",
  "Neurologic Surgery - General - Cervical dorsal laminectomy",
  "Neurologic Surgery - General - Cervical traction stabilization",
  "Neurologic Surgery - General - Cervical ventral slot",
  "Neurologic Surgery - General - Craniectomy",
  "Neurologic Surgery - General - Craniotomy",
  "Neurologic Surgery - General - Disc fenestration",
  "Neurologic Surgery - General - Dorsal cervical stabilization",
  "Neurologic Surgery - General - Epineural neurorrhaphy",
  "Neurologic Surgery - General - External fixator",
  "Neurologic Surgery - General - Facetectomy",
  "Neurologic Surgery - General - Foramenotomy",
  "Neurologic Surgery - General - Hemilaminectomy",
  "Neurologic Surgery - General - Hypophysectomy",
  "Neurologic Surgery - General - Lubra plate",
  "Neurologic Surgery - General - Lumbosacral dorsal laminectomy",
  "Neurologic Surgery - General - Open biopsy",
  "Neurologic Surgery - General - Pediculectomy",
  "Neurologic Surgery - General - Pins and methylmethacrylate",
  "Neurologic Surgery - General - Spinal stapling",
  "Neurologic Surgery - General - Spinal wiring",
  "Neurologic Surgery - General - Thoracolumbar dorsal laminectomy",
  "Neurologic Surgery - General - Transilial bolt",
  "Neurologic Surgery - General - Transilial pin",
  "Neurologic Surgery - General - Ventral cervical stabilization",
  "Neurologic Surgery - General - Vertebral body plate",

  // Orthopedics - Advanced
  "Orthopedics - Advanced - Corrective osteotomies - Corrective osteotomy",
  "Orthopedics - Advanced - Corrective osteotomies - Triple/double pelvic osteotomy",
  "Orthopedics - Advanced - Joint Replacement - Total elbow arthroplasty",
  "Orthopedics - Advanced - Joint Replacement - Total Elbow Replacement",
  "Orthopedics - Advanced - Joint Replacement - Total hip arthroplasty, cemented",
  "Orthopedics - Advanced - Joint Replacement - Total hip arthroplasty, hybrid",
  "Orthopedics - Advanced - Joint Replacement - Total hip arthroplasty, uncemented",
  "Orthopedics - Advanced - Joint Replacement - Total Hip Replacement",
  "Orthopedics - Advanced - Joint Replacement - Total Knee Replacement",
  "Orthopedics - Advanced - Joint Replacement - Total Shoulder Replacement",
  "Orthopedics - Advanced - Joint Replacement - Total Stifle Arthroplasty",
  "Orthopedics - Advanced - Limb Sparing - Limb sparing with allograft",
  "Orthopedics - Advanced - Limb Sparing - Limb sparing with bone transport",
  "Orthopedics - Advanced - Limb Sparing - Limb sparing with custom implant",
  "Orthopedics - Advanced - Limb Sparing - Partial pelvectomy",
  "Orthopedics - Advanced - Limb Sparing - Scapulectomy",

  // Orthopedics - Fracture
  "Orthopedics - Fracture - Fractures - Elbow arthrodesis to treat fracture",
  "Orthopedics - Fracture - Fractures - Fracture repair, bone plate",
  "Orthopedics - Fracture - Fractures - Fracture repair, bone plate & IM pin",
  "Orthopedics - Fracture - Fractures - Fracture repair, bone screws",
  "Orthopedics - Fracture - Fractures - Fracture repair, circular external fixator",
  "Orthopedics - Fracture - Fractures - Fracture repair, clamp rod internal fixator",
  "Orthopedics - Fracture - Fractures - Fracture repair, external fixator & IM pin",
  "Orthopedics - Fracture - Fractures - Fracture repair, hybrid external fixator",
  "Orthopedics - Fracture - Fractures - Fracture repair, IM pin & wire",
  "Orthopedics - Fracture - Fractures - Fracture repair, interfragmentary wire",
  "Orthopedics - Fracture - Fractures - Fracture repair, interlocking nail",
  "Orthopedics - Fracture - Fractures - Fracture repair, linear external fixator",
  "Orthopedics - Fracture - Fractures - Fracture repair, pins",
  "Orthopedics - Fracture - Fractures - Fracture repair, tension band",
  "Orthopedics - Fracture - Fractures - Iliosacral lag screw",
  "Orthopedics - Fracture - Fractures - Mandibular fracture repair",
  "Orthopedics - Fracture - Fractures - Pancarpal arthrodesis to treat fracture",
  "Orthopedics - Fracture - Fractures - Pantarsal arthrodesis to treat fracture",
  "Orthopedics - Fracture - Fractures - Partial carpal arthrodesis to treat fracture",
  "Orthopedics - Fracture - Fractures - Partial tarsal arthrodesis to treat fracture",
  "Orthopedics - Fracture - Fractures - Shoulder arthrodesis to treat fracture",

  // Orthopedics - Non-Fracture Joint
  "Orthopedics - Non-Fracture Joint - Carpus - Pancarpal arthrodesis",
  "Orthopedics - Non-Fracture Joint - Carpus - Partial carpal arthrodesis",
  "Orthopedics - Non-Fracture Joint - Carpus - Radial carpal bone reduction and stabilization",
  "Orthopedics - Non-Fracture Joint - Carpus - Shearing injury stabilization",
  "Orthopedics - Non-Fracture Joint - Elbow - Anconeal process stabilization, lag screw",
  "Orthopedics - Non-Fracture Joint - Elbow - Canine Unicompartmental Elbow - CUE",
  "Orthopedics - Non-Fracture Joint - Elbow - Elbow arthrodesis",
  "Orthopedics - Non-Fracture Joint - Elbow - Exploratory arthrotomy with fragment retrieval",
  "Orthopedics - Non-Fracture Joint - Elbow - Open reduction and stabilization",
  "Orthopedics - Non-Fracture Joint - Hip - Femoral head and neck ostectomy",
  "Orthopedics - Non-Fracture Joint - Hip - Hip reduction and capsulorrhaphy",
  "Orthopedics - Non-Fracture Joint - Hip - Hip reduction and iliofemoral suture",
  "Orthopedics - Non-Fracture Joint - Hip - Hip reduction and prosthetic capsule",
  "Orthopedics - Non-Fracture Joint - Hip - Hip reduction and toggle pin",
  "Orthopedics - Non-Fracture Joint - Hip - Hip reduction and transarticular pin",
  "Orthopedics - Non-Fracture Joint - Hip - Hip reduction and triple pelvic osteotomy",
  "Orthopedics - Non-Fracture Joint - Joints general - Exploratory arthrotomy",
  "Orthopedics - Non-Fracture Joint - Joints general - Exploratory arthrotomy with fragment retrieval",
  "Orthopedics - Non-Fracture Joint - Shoulder - Biceps tendon tenodesis",
  "Orthopedics - Non-Fracture Joint - Shoulder - Biceps tenotomy",
  "Orthopedics - Non-Fracture Joint - Shoulder - Excision arthroplasty",
  "Orthopedics - Non-Fracture Joint - Shoulder - Open reduction and stabilization",
  "Orthopedics - Non-Fracture Joint - Shoulder - Shoulder arthrodesis",
  "Orthopedics - Non-Fracture Joint - Stifle - Fibular head transposition",
  "Orthopedics - Non-Fracture Joint - Stifle - Lateral fabellar suture(s)",
  "Orthopedics - Non-Fracture Joint - Stifle - Lateral retinacular stabilization",
  "Orthopedics - Non-Fracture Joint - Stifle - Meniscal release",
  "Orthopedics - Non-Fracture Joint - Stifle - Meniscectomy",
  "Orthopedics - Non-Fracture Joint - Stifle - Open reduction and stabilization",
  "Orthopedics - Non-Fracture Joint - Stifle - Over the top stabilization",
  "Orthopedics - Non-Fracture Joint - Stifle - Paatsama stabilization",
  "Orthopedics - Non-Fracture Joint - Stifle - Posterior capsulorrhaphy",
  "Orthopedics - Non-Fracture Joint - Stifle - Primary collateral ligament repair",
  "Orthopedics - Non-Fracture Joint - Stifle - Tibial plateau leveling osteotomy",
  "Orthopedics - Non-Fracture Joint - Stifle - Tibial tuberosity advancement",
  "Orthopedics - Non-Fracture Joint - Stifle - Tibial tuberosity transposition",
  "Orthopedics - Non-Fracture Joint - Stifle - Trochlear recession block",
  "Orthopedics - Non-Fracture Joint - Stifle - Trochlear recession wedge",
  "Orthopedics - Non-Fracture Joint - Stifle - Trochlear sulcoplasty",
  "Orthopedics - Non-Fracture Joint - Stifle - Under and over fascial repair",
  "Orthopedics - Non-Fracture Joint - Tarsus - Exploratory arthrotomy with fragment retrieval",
  "Orthopedics - Non-Fracture Joint - Tarsus - Open reduction and stabilization",
  "Orthopedics - Non-Fracture Joint - Tarsus - Pantarsal arthrodesis",
  "Orthopedics - Non-Fracture Joint - Tarsus - Partial tarsal arthrodesis",

  // Orthopedics - Other
  "Orthopedics - Other - Corrective osteotomies - Corrective osteotomy, bone plate",
  "Orthopedics - Other - Corrective osteotomies - Corrective osteotomy, circular fixator",
  "Orthopedics - Other - Corrective osteotomies - Corrective osteotomy, linear external fixator",
  "Orthopedics - Other - Corrective osteotomies - Ostectomy",
  "Orthopedics - Other - Corrective osteotomies - Release osteotomy",
  "Orthopedics - Other - Corrective osteotomies - Subtrochanteric derotational varus osteotomy",
  "Orthopedics - Other - Corrective osteotomies - Triple/double pelvic osteotomy",
  "Orthopedics - Other - Miscellaneous - Complex implant removal",
  "Orthopedics - Other - Miscellaneous - Limb sparing with allograft",
  "Orthopedics - Other - Miscellaneous - Limb sparing with bone transport",
  "Orthopedics - Other - Miscellaneous - Partial pelvectomy",
  "Orthopedics - Other - Miscellaneous - Pelvic symphysiodesis",
  "Orthopedics - Other - Miscellaneous - Repair muscle laceration",
  "Orthopedics - Other - Miscellaneous - Repair musculotendon rupture",
  "Orthopedics - Other - Miscellaneous - Scapulectomy",
  "Orthopedics - Other - Miscellaneous - Tendon/muscle release",
  "Orthopedics - Other - Miscellaneous - Tendonorrhaphy",
  "Orthopedics - Other - Miscellaneous - Transilial bolt",

  // Skin/Reconstructive
  "Skin/Reconstructive Surgery - General - Advancement flap",
  "Skin/Reconstructive Surgery - General - Anal sacculectomy",
  "Skin/Reconstructive Surgery - General - Axial pattern flap",
  "Skin/Reconstructive Surgery - General - Caudectomy",
  "Skin/Reconstructive Surgery - General - Complete caudectomy",
  "Skin/Reconstructive Surgery - General - Coxofemoral disarticulation/hind limb amputation",
  "Skin/Reconstructive Surgery - General - Digit amputation",
  "Skin/Reconstructive Surgery - General - Forequarter amputation",
  "Skin/Reconstructive Surgery - General - Free skin graft with microvascular anastomosis",
  "Skin/Reconstructive Surgery - General - Full thickness skin graft",
  "Skin/Reconstructive Surgery - General - Hemipelvectomy",
  "Skin/Reconstructive Surgery - General - Interpolation flap",
  "Skin/Reconstructive Surgery - General - Local mastectomy",
  "Skin/Reconstructive Surgery - General - Mesh graft",
  "Skin/Reconstructive Surgery - General - Midfemoral amputation",
  "Skin/Reconstructive Surgery - General - Midhumeral amputation",
  "Skin/Reconstructive Surgery - General - Muscle flap",
  "Skin/Reconstructive Surgery - General - Myocutaneous flap",
  "Skin/Reconstructive Surgery - General - Omental flap",
  "Skin/Reconstructive Surgery - General - Partial caudectomy",
  "Skin/Reconstructive Surgery - General - Partial pelvectomy/hind limb amputation",
  "Skin/Reconstructive Surgery - General - Pedicle flap",
  "Skin/Reconstructive Surgery - General - Perianal fistula resection",
  "Skin/Reconstructive Surgery - General - Perineal herniorrhaphy",
  "Skin/Reconstructive Surgery - General - Pinch graft",
  "Skin/Reconstructive Surgery - General - Pouch or hinge flap",
  "Skin/Reconstructive Surgery - General - Radical mastectomy",
  "Skin/Reconstructive Surgery - General - Regional mastectomy",
  "Skin/Reconstructive Surgery - General - Rotational flap",
  "Skin/Reconstructive Surgery - General - Skin fold resection",
  "Skin/Reconstructive Surgery - General - Split thickness skin graft",
  "Skin/Reconstructive Surgery - General - Transposition flap",

  // Thoracic
  "Thoracic Surgery - Cardiovascular - Excision right atrial appendage",
  "Thoracic Surgery - Cardiovascular - Patch-graft valvuloplasty",
  "Thoracic Surgery - Cardiovascular - PDA ligation",
  "Thoracic Surgery - Cardiovascular - Pulmonary artery banding",
  "Thoracic Surgery - Cardiovascular - Subtotal pericardiectomy",
  "Thoracic Surgery - Cardiovascular - Systemic to pulmonary shunt",
  "Thoracic Surgery - Cardiovascular - Total pericardiectomy",
  "Thoracic Surgery - Cardiovascular - Transdiaphragmatic pacemaker",
  "Thoracic Surgery - Cardiovascular - Transect ligamentum arteriosum for persistent right aortic arch",
  "Thoracic Surgery - Esophagus - Esophageal resection/anastomosis",
  "Thoracic Surgery - Esophagus - Esophagotomy",
  "Thoracic Surgery - General - Intrathoracic mass removal",
  "Thoracic Surgery - General - Lateral thoracotomy",
  "Thoracic Surgery - General - Lymph node resection",
  "Thoracic Surgery - General - Median sternotomy",
  "Thoracic Surgery - General - Mediastinal mass removal",
  "Thoracic Surgery - General - Omentalization",
  "Thoracic Surgery - General - Pleural biopsy",
  "Thoracic Surgery - General - Rib resection",
  "Thoracic Surgery - General - Thoracic duct ligation",
  "Thoracic Surgery - General - Thoracic wall en bloc resection",
  "Thoracic Surgery - General - Thoracoscopy",
  "Thoracic Surgery - General - Thoracotomy, median sternotomy",
  "Thoracic Surgery - General - Thoracotomy - General - Thymectomy",
  "Thoracic Surgery - Lung - Complete lung lobectomy",
  "Thoracic Surgery - Lung - Lung biopsy",
  "Thoracic Surgery - Lung - Partial lung lobectomy",

  // Urogenital - SA
  "Urogenital - SA - Prostate - Prostatectomy",
  "Urogenital - SA - Prostate - Prostatic biopsy",
  "Urogenital - SA - Prostate - Prostatic marsupialization",
  "Urogenital - SA - Prostate - Prostatic omentalization",
  "Urogenital - SA - Prostate - Subtotal/partial prostatectomy",
  "Urogenital - SA - Reproductive - Abdominal cryptorchid orchiectomy",
  "Urogenital - SA - Reproductive - Cesarean section",
  "Urogenital - SA - Reproductive - Culposuspension",
  "Urogenital - SA - Reproductive - Episiotomy",
  "Urogenital - SA - Reproductive - Hysterectomy",
  "Urogenital - SA - Reproductive - Ovariohysterectomy for pyometra",
  "Urogenital - SA - Reproductive - Uterine prolapse reduction",
  "Urogenital - SA - Reproductive - Vaginal mass excision",
  "Urogenital - SA - Reproductive - Vaginal prolapse reduction/resection",
  "Urogenital - SA - Reproductive - Vaginectomy",
  "Urogenital - SA - Urinary - Cystic biopsy",
  "Urogenital - SA - Urinary - Cystostomy tube placement",
  "Urogenital - SA - Urinary - Cystotomy",
  "Urogenital - SA - Urinary - Ectopic ureter repair",
  "Urogenital - SA - Urinary - Neoureterostomy",
  "Urogenital - SA - Urinary - Nephrectomy",
  "Urogenital - SA - Urinary - Nephrotomy",
  "Urogenital - SA - Urinary - Open placement of nephrostomy tube",
  "Urogenital - SA - Urinary - Open renal biopsy",
  "Urogenital - SA - Urinary - Partial cystectomy",
  "Urogenital - SA - Urinary - Partial nephrectomy",
  "Urogenital - SA - Urinary - Partial penile amputation",
  "Urogenital - SA - Urinary - Penile amputation",
  "Urogenital - SA - Urinary - Perineal urethrostomy",
  "Urogenital - SA - Urinary - Preputial reconstruction",
  "Urogenital - SA - Urinary - Prescrotal urethrostomy",
  "Urogenital - SA - Urinary - Renal transplant",
  "Urogenital - SA - Urinary - Scrotal urethrostomy",
  "Urogenital - SA - Urinary - SUB placement",
  "Urogenital - SA - Urinary - Ureteral anastomosis",
  "Urogenital - SA - Urinary - Ureteroneocystostomy",
  "Urogenital - SA - Urinary - Ureterotomy",
  "Urogenital - SA - Urinary - Urethral prolapse repair",
  "Urogenital - SA - Urinary - Urethral reduction/resection",
  "Urogenital - SA - Urinary - Urethral sling",
  "Urogenital - SA - Urinary - Urethrotomy",
  "Urogenital - SA - Urinary - Pyelotomy"
];

// Helper to generate weeks from Jan 6, 2025 to Dec 29, 2025
const generateSchedule = () => {
    const weeks: RotationWeek[] = [];
    // Start Jan 6, 2025 (Monday)
    let d = new Date(2025, 0, 6, 12, 0, 0); 
    const end = new Date(2026, 6, 6, 12, 0, 0); // Jul 6 2026

    while(d < end) {
        weeks.push({
            weekStart: d.toISOString().split('T')[0],
            assignments: USERS.filter(u => u.role === 'Resident').map(r => ({ residentId: r.id, assignment: '' }))
        });
        d.setDate(d.getDate() + 7);
    }
    return weeks;
}

export const ROTATION_SCHEDULE: RotationWeek[] = [
  ...generateSchedule(),
  {
    weekStart: '2026-07-06',
    assignments: [
      { residentId: '9', assignment: 'Allen/Aeschlimann' },
      { residentId: '7', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '8', assignment: 'Internal Medicine (Portanova)' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-07-13',
    assignments: [
      { residentId: '9', assignment: 'Allen/Aeschlimann' },
      { residentId: '7', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '8', assignment: 'Internal Medicine (Portanova)' },
      { residentId: '12', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-07-20',
    assignments: [
      { residentId: '9', assignment: 'Allen/Aeschlimann' },
      { residentId: '7', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '8', assignment: 'Internal Medicine (Portanova)' },
      { residentId: '12', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-07-27',
    assignments: [
      { residentId: '9', assignment: 'Research (V)' },
      { residentId: '7', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '8', assignment: 'Allen/Aeschlimann' },
      { residentId: '12', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-08-03',
    assignments: [
      { residentId: '9', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '7', assignment: 'Allen/Aeschlimann' },
      { residentId: '8', assignment: 'Allen/Aeschlimann' },
      { residentId: '12', assignment: 'Anesthesia (Ryan)' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-08-10',
    assignments: [
      { residentId: '9', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '7', assignment: 'Allen/Aeschlimann' },
      { residentId: '8', assignment: 'Clinical Pathology' },
      { residentId: '12', assignment: 'Anesthesia (Marquis)' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-08-17',
    assignments: [
      { residentId: '9', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '7', assignment: 'Allen/Aeschlimann' },
      { residentId: '8', assignment: 'Anatomic Pathology' },
      { residentId: '12', assignment: 'Research' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-08-24',
    assignments: [
      { residentId: '9', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '7', assignment: 'Research' },
      { residentId: '8', assignment: 'Allen/Aeschlimann' },
      { residentId: '12', assignment: 'Allen/Aeschlimann' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-08-31',
    assignments: [
      { residentId: '9', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '7', assignment: 'Allen/Aeschlimann' },
      { residentId: '8', assignment: 'Research' },
      { residentId: '12', assignment: 'Allen/Aeschlimann' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-09-07',
    assignments: [
      { residentId: '9', assignment: 'Allen/Aeschlimann' },
      { residentId: '7', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '8', assignment: 'Allen/Aeschlimann' },
      { residentId: '12', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-09-14',
    assignments: [
      { residentId: '9', assignment: 'Allen/Aeschlimann' },
      { residentId: '7', assignment: 'Allen/Aeschlimann' },
      { residentId: '8', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '12', assignment: 'Research' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-09-21',
    assignments: [
      { residentId: '9', assignment: 'Research' },
      { residentId: '7', assignment: 'Allen/Aeschlimann' },
      { residentId: '8', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '12', assignment: 'Allen/Aeschlimann' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-09-28',
    assignments: [
      { residentId: '9', assignment: 'Vacation' },
      { residentId: '7', assignment: 'Allen/Aeschlimann' },
      { residentId: '8', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '12', assignment: 'Allen/Aeschlimann' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-10-05',
    assignments: [
      { residentId: '9', assignment: 'ACVS' },
      { residentId: '7', assignment: 'ACVS' },
      { residentId: '8', assignment: 'Allen/Aeschlimann' },
      { residentId: '12', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-10-12',
    assignments: [
      { residentId: '9', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '7', assignment: 'Research' },
      { residentId: '8', assignment: 'Allen/Aeschlimann' },
      { residentId: '12', assignment: 'Allen/Aeschlimann' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-10-19',
    assignments: [
      { residentId: '9', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '7', assignment: 'Allen/Aeschlimann' },
      { residentId: '8', assignment: 'Research (V)' },
      { residentId: '12', assignment: 'Allen/Aeschlimann' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-10-26',
    assignments: [
      { residentId: '9', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '7', assignment: 'Allen/Aeschlimann' },
      { residentId: '8', assignment: 'Vacation' },
      { residentId: '12', assignment: 'Allen/Aeschlimann' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-11-02',
    assignments: [
      { residentId: '9', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '7', assignment: 'Allen/Aeschlimann' },
      { residentId: '8', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '12', assignment: 'Radiology' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-11-09',
    assignments: [
      { residentId: '9', assignment: 'Allen/Aeschlimann' },
      { residentId: '7', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '8', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '12', assignment: 'Radiology' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-11-16',
    assignments: [
      { residentId: '9', assignment: 'Research (V)' },
      { residentId: '7', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '8', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '12', assignment: 'Allen/Aeschlimann' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-11-23',
    assignments: [
      { residentId: '9', assignment: 'Allen/Aeschlimann' },
      { residentId: '7', assignment: 'Research' },
      { residentId: '8', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '12', assignment: 'Allen/Aeschlimann' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-11-30',
    assignments: [
      { residentId: '9', assignment: 'Allen/Aeschlimann' },
      { residentId: '7', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '8', assignment: 'Allen/Aeschlimann' },
      { residentId: '12', assignment: 'Research (V)' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-12-07',
    assignments: [
      { residentId: '9', assignment: 'Allen/Aeschlimann' },
      { residentId: '7', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '8', assignment: 'Allen/Aeschlimann' },
      { residentId: '12', assignment: 'Vacation' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-12-14',
    assignments: [
      { residentId: '9', assignment: 'Research' },
      { residentId: '7', assignment: 'Allen/Aeschlimann' },
      { residentId: '8', assignment: 'Allen/Aeschlimann' },
      { residentId: '12', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-12-21',
    assignments: [
      { residentId: '9', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '7', assignment: 'Vacation' },
      { residentId: '8', assignment: 'Allen/Aeschlimann' },
      { residentId: '12', assignment: 'Research' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2026-12-28',
    assignments: [
      { residentId: '9', assignment: 'Vacation' },
      { residentId: '7', assignment: 'Allen/Aeschlimann' },
      { residentId: '8', assignment: 'Research' },
      { residentId: '12', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2027-01-04',
    assignments: [
      { residentId: '9', assignment: 'Allen/Aeschlimann' },
      { residentId: '7', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '8', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '12', assignment: 'Allen/Aeschlimann' },
      { residentId: '6', assignment: '' }
    ]
  },
  {
    weekStart: '2027-01-11',
    assignments: [
      { residentId: '9', assignment: 'Allen/Aeschlimann' },
      { residentId: '7', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '8', assignment: 'Friesen/Wilson/Marquiss' },
      { residentId: '12', assignment: 'Allen/Aeschlimann' },
      { residentId: '6', assignment: '' }
    ]
  }

];

// COMPREHENSIVE VETERINARY DRUG FORMULARY
export const VETERINARY_DRUGS: Drug[] = [
  // --- Antibiotics ---
  { id: 'ab-1', name: 'Amoxicillin', category: 'Antibiotic', concentration: 50, defaultDosage: 20, doseRange: '10-22 mg/kg PO q12h', indications: 'Soft tissue inf, UTI, Respiratory', sideEffects: 'GI upset, hypersensitivity', species: 'Both', contraindications: ['Penicillin Allergy'], notes: 'Broad-spectrum. Often combined with clavulanate.' },
  { id: 'ab-2', name: 'Ampicillin/Sulbactam (Unasyn)', category: 'Antibiotic', concentration: 30, defaultDosage: 30, doseRange: '20-50 mg/kg IV q8h', indications: 'Septic abdomen, pneumonia, prophylaxis', sideEffects: 'Injection pain, GI upset', species: 'Both', contraindications: ['Penicillin Allergy'], notes: 'IV slowly over 10-15 mins.' },
  { id: 'ab-3', name: 'Cefazolin', category: 'Antibiotic', concentration: 100, defaultDosage: 22, doseRange: '22 mg/kg IV q90min intra-op', indications: 'Surgical prophylaxis', sideEffects: 'Hypersensitivity', species: 'Both', contraindications: ['Cephalosporin Allergy'], notes: 'Primary surgical prophylaxis.' },
  { id: 'ab-4', name: 'Cefovecin (Convenia)', category: 'Antibiotic', concentration: 80, defaultDosage: 8, doseRange: '8 mg/kg SQ once', indications: 'Skin/Soft tissue inf, UTI', sideEffects: 'GI upset, Lethargy', species: 'Both', contraindications: ['Cephalosporin Allergy'], notes: 'Long-acting injectable (14 days).' },
  { id: 'ab-5', name: 'Clindamycin', category: 'Antibiotic', concentration: 150, defaultDosage: 11, doseRange: '5.5-11 mg/kg PO q12h', indications: 'Dental, Osteomyelitis, Abscesses', sideEffects: 'Esophagitis (cats), GI upset', species: 'Both', contraindications: [], notes: 'Follow with water/food to prevent esophagitis.' },
  { id: 'ab-6', name: 'Enrofloxacin (Baytril)', category: 'Antibiotic', concentration: 22.7, defaultDosage: 10, doseRange: '5-20 mg/kg PO/IV q24h (Dog)', indications: 'Gram-negative, Pseudomonas', sideEffects: 'Retinal toxicity (Cats >5mg/kg), Cartilage damage (young)', species: 'Both', contraindications: ['Growing animals', 'Seizure history'], notes: 'Max 5mg/kg/day in Cats.' },
  { id: 'ab-7', name: 'Metronidazole', category: 'Antibiotic', concentration: 5, defaultDosage: 10, doseRange: '10-15 mg/kg PO/IV q12h', indications: 'Anaerobes, Giardia, Diarrhea', sideEffects: 'Neurotoxicity (high dose), Anorexia', species: 'Both', contraindications: ['Liver failure'], notes: 'Neurotoxicity seen at >30mg/kg/day.' },
  { id: 'ab-8', name: 'Doxycycline', category: 'Antibiotic', concentration: 10, defaultDosage: 10, doseRange: '5-10 mg/kg PO q12-24h', indications: 'Tick-borne disease, Respiratory', sideEffects: 'Esophageal stricture (cats), GI upset', species: 'Both', contraindications: [], notes: 'MUST flush with water in cats.' },
  { id: 'ab-9', name: 'Amoxicillin/Clavulanate (Clavamox)', category: 'Antibiotic', concentration: 62.5, defaultDosage: 13.75, doseRange: '13.75-20 mg/kg PO q12h', indications: 'Skin, UTI, Soft tissue', sideEffects: 'GI upset', species: 'Both', contraindications: ['Penicillin Allergy'], notes: 'Tablets are foil-wrapped, moisture sensitive.' },

  // --- Analgesics (NSAIDs) ---
  { id: 'nsaid-1', name: 'Carprofen (Rimadyl)', category: 'Analgesic (NSAID)', concentration: 50, defaultDosage: 4.4, doseRange: '2.2 mg/kg PO q12h OR 4.4 mg/kg PO q24h', indications: 'Osteoarthritis, Post-op pain', sideEffects: 'GI ulceration, Renal/Hepatic toxicity', species: 'Canine', contraindications: ['Cats (long term)', 'Bleeding disorders', 'Steroids'], notes: 'Injectable and oral. Dog only.' },
  { id: 'nsaid-2', name: 'Meloxicam (Metacam)', category: 'Analgesic (NSAID)', concentration: 5, defaultDosage: 0.1, doseRange: 'Dogs: 0.1 mg/kg PO q24h. Cats: 0.3 mg/kg SQ ONCE.', indications: 'Pain, Inflammation', sideEffects: 'Renal toxicity (Cats), GI ulcers', species: 'Both', contraindications: ['Renal failure', 'Steroids'], notes: 'Review Cat dose carefully. Single shot only for cats usually.' },
  { id: 'nsaid-3', name: 'Grapiprant (Galliprant)', category: 'Analgesic (NSAID)', concentration: 0, defaultDosage: 2, doseRange: '2 mg/kg PO q24h', indications: 'Osteoarthritis pain', sideEffects: 'Mild GI signs', species: 'Canine', contraindications: [], notes: 'Piprant class (EP4 antagonist). Safer for liver/kidney.' },
  { id: 'nsaid-4', name: 'Robenacoxib (Onsior)', category: 'Analgesic (NSAID)', concentration: 20, defaultDosage: 2, doseRange: '1-2.4 mg/kg PO q24h (Max 3 days)', indications: 'Post-op pain in Cats', sideEffects: 'GI upset', species: 'Feline', contraindications: [], notes: 'Approved for cats (max 3 days).' },

  // --- Analgesics (Opioids) ---
  { id: 'op-1', name: 'Buprenorphine', category: 'Analgesic (Opioid)', concentration: 0.3, defaultDosage: 0.02, doseRange: '0.01-0.03 mg/kg IV/IM/Buccal q6-8h', indications: 'Mild-Moderate pain', sideEffects: 'Sedation, Respiratory depression', species: 'Both', contraindications: [], notes: 'Partial mu agonist. Simbadol is high dose SQ for cats.' },
  { id: 'op-2', name: 'Butorphanol', category: 'Analgesic (Opioid)', concentration: 10, defaultDosage: 0.2, doseRange: '0.1-0.4 mg/kg IV/IM q2-4h', indications: 'Mild pain, Sedation, Cough', sideEffects: 'Sedation', species: 'Both', contraindications: [], notes: 'Kappa agonist, Mu antagonist. Weak analgesic, good sedative.' },
  { id: 'op-3', name: 'Fentanyl (Injectable)', category: 'Analgesic (Opioid)', concentration: 0.05, defaultDosage: 0.005, doseRange: '2-10 mcg/kg IV loading, then CRI', indications: 'Severe pain', sideEffects: 'Bradycardia, Apnea', species: 'Both', contraindications: ['Hypoventilation'], notes: 'Short acting. CRI essential.' },
  { id: 'op-4', name: 'Hydromorphone', category: 'Analgesic (Opioid)', concentration: 2, defaultDosage: 0.1, doseRange: '0.05-0.2 mg/kg IV/IM q4-6h', indications: 'Moderate-Severe pain', sideEffects: 'Vomiting, Panting, Bradycardia', species: 'Both', contraindications: ['Head trauma'], notes: 'Full mu agonist.' },
  { id: 'op-5', name: 'Methadone', category: 'Analgesic (Opioid)', concentration: 10, defaultDosage: 0.2, doseRange: '0.1-0.5 mg/kg IV/IM q4-6h', indications: 'Severe pain, NMDA antagonism', sideEffects: 'Bradycardia, Panting', species: 'Both', contraindications: [], notes: 'Less vomiting than hydro/morphine. NMDA affinity helps wind-up.' },
  { id: 'op-6', name: 'Morphine', category: 'Analgesic (Opioid)', concentration: 15, defaultDosage: 0.5, doseRange: '0.25-1.0 mg/kg IM/SQ (Lower IV)', indications: 'Severe pain', sideEffects: 'Histamine release (IV), Vomiting', species: 'Both', contraindications: ['Mast Cell Tumor'], notes: 'Give IV very slowly to avoid histamine reaction.' },
  { id: 'op-7', name: 'Tramadol', category: 'Analgesic', concentration: 50, defaultDosage: 4, doseRange: '2-5 mg/kg PO q8-12h', indications: 'Chronic pain', sideEffects: 'Sedation, Constipation', species: 'Both', contraindications: ['Seizures', 'SSRI use'], notes: 'Bitter taste. Efficacy in dogs is debated.' },

  // --- Analgesics (Adjuncts) ---
  { id: 'adj-1', name: 'Gabapentin', category: 'Analgesic (Adjunct)', concentration: 100, defaultDosage: 10, doseRange: '5-20 mg/kg PO q8-12h', indications: 'Neuropathic pain, Anxiety', sideEffects: 'Sedation, Ataxia', species: 'Both', contraindications: [], notes: 'Taper if on long term.' },
  { id: 'adj-2', name: 'Amantadine', category: 'Analgesic (Adjunct)', concentration: 100, defaultDosage: 3, doseRange: '3-5 mg/kg PO q24h', indications: 'Chronic pain, Wind-up', sideEffects: 'Agitation, GI upset', species: 'Both', contraindications: ['Renal failure'], notes: 'NMDA antagonist.' },

  // --- Anesthetics / Sedatives ---
  { id: 'anes-1', name: 'Acepromazine', category: 'Sedative', concentration: 10, defaultDosage: 0.05, doseRange: '0.01-0.05 mg/kg IV/IM', indications: 'Tranquilization', sideEffects: 'Hypotension, Splenic enlargement', species: 'Both', contraindications: ['Hypovolemia', 'Coagulopathy'], notes: 'No analgesia. Long duration.' },
  { id: 'anes-2', name: 'Alfaxalone', category: 'Anesthetic', concentration: 10, defaultDosage: 2, doseRange: '1-3 mg/kg IV induction', indications: 'Induction', sideEffects: 'Apnea, Twitching on recovery', species: 'Both', contraindications: [], notes: 'Can be given IM to cats.' },
  { id: 'anes-3', name: 'Dexmedetomidine', category: 'Sedative', concentration: 0.5, defaultDosage: 0.005, doseRange: '1-10 mcg/kg IV/IM', indications: 'Sedation, Analgesia', sideEffects: 'Bradycardia, Peripheral vasoconstriction', species: 'Both', contraindications: ['Cardiac disease', 'Shock'], notes: 'Reversable with Atipamezole.' },
  { id: 'anes-4', name: 'Diazepam (Valium)', category: 'Sedative', concentration: 5, defaultDosage: 0.25, doseRange: '0.2-0.5 mg/kg IV', indications: 'Muscle relaxant, Seizures', sideEffects: 'Liver failure (cats oral)', species: 'Both', contraindications: [], notes: 'Propylene glycol base - do not give IM reliably.' },
  { id: 'anes-5', name: 'Ketamine', category: 'Anesthetic', concentration: 100, defaultDosage: 5, doseRange: '2-10 mg/kg IV (Induction)', indications: 'Dissociative anesthesia, Analgesia', sideEffects: 'Tachycardia, Muscle rigidity', species: 'Both', contraindications: ['HCM', 'Glaucoma', 'High ICP'], notes: 'Combine with benzo for muscle relaxation.' },
  { id: 'anes-6', name: 'Midazolam', category: 'Sedative', concentration: 5, defaultDosage: 0.2, doseRange: '0.1-0.4 mg/kg IV/IM', indications: 'Pre-med, Seizures', sideEffects: 'Excitation (if alone in healthy)', species: 'Both', contraindications: [], notes: 'Cardiovascularly safe.' },
  { id: 'anes-7', name: 'Propofol', category: 'Anesthetic', concentration: 10, defaultDosage: 4, doseRange: '2-6 mg/kg IV to effect', indications: 'Induction', sideEffects: 'Apnea, Hypotension', species: 'Both', contraindications: [], notes: 'Heinz body anemia in cats with repeated use.' },
  { id: 'anes-8', name: 'Trazodone', category: 'Sedative', concentration: 50, defaultDosage: 5, doseRange: '3-10 mg/kg PO q12h', indications: 'Anxiety, Post-op confinement', sideEffects: 'Sedation', species: 'Canine', contraindications: ['MAOI use'], notes: 'Use with caution in cats.' },

  // --- Reversals ---
  { id: 'rev-1', name: 'Atipamezole (Antisedan)', category: 'Reversal', concentration: 5, defaultDosage: 0.05, doseRange: 'Equal volume to Dexmedetomidine', indications: 'Reverse Alpha-2s', sideEffects: 'Tachycardia, Alertness', species: 'Both', contraindications: [], notes: 'IM injection recommended.' },
  { id: 'rev-2', name: 'Flumazenil', category: 'Reversal', concentration: 0.1, defaultDosage: 0.01, doseRange: '0.01-0.02 mg/kg IV', indications: 'Reverse Benzodiazepines', sideEffects: 'Seizures (if benzo was for seizure)', species: 'Both', contraindications: [], notes: '' },
  { id: 'rev-3', name: 'Naloxone', category: 'Reversal', concentration: 0.4, defaultDosage: 0.04, doseRange: '0.01-0.04 mg/kg IV/IM', indications: 'Reverse Opioids', sideEffects: 'Pain, Tachycardia', species: 'Both', contraindications: [], notes: 'Short duration - may need redose.' },

  // --- Emergency / CPR ---
  { id: 'em-1', name: 'Atropine', category: 'Emergency', concentration: 0.54, defaultDosage: 0.04, doseRange: '0.02-0.04 mg/kg IV', indications: 'Bradycardia, CPR', sideEffects: 'Tachycardia, Ileus', species: 'Both', contraindications: ['Glaucoma', 'Tachycardia'], notes: 'Crosses BBB.' },
  { id: 'em-2', name: 'Epinephrine (Low Dose)', category: 'Emergency', concentration: 1, defaultDosage: 0.01, doseRange: '0.01 mg/kg IV (1:1000)', indications: 'Anaphylaxis', sideEffects: 'Arrhythmias, Hypertension', species: 'Both', contraindications: [], notes: '' },
  { id: 'em-3', name: 'Epinephrine (CPR)', category: 'Emergency', concentration: 1, defaultDosage: 0.1, doseRange: '0.1 mg/kg IV (High Dose) usually start 0.01', indications: 'Cardiac Arrest', sideEffects: '', species: 'Both', contraindications: [], notes: 'Follow RECOVER guidelines.' },
  { id: 'em-4', name: 'Glycopyrrolate', category: 'Emergency', concentration: 0.2, defaultDosage: 0.01, doseRange: '0.005-0.01 mg/kg IV/IM', indications: 'Bradycardia', sideEffects: 'Ileus', species: 'Both', contraindications: [], notes: 'Slower onset than Atropine. No BBB cross.' },
  { id: 'em-5', name: 'Lidocaine 2%', category: 'Emergency', concentration: 20, defaultDosage: 2, doseRange: '2 mg/kg IV bolus (Dog)', indications: 'VPC/VTach, Local block', sideEffects: 'Seizures, Nausea', species: 'Canine', contraindications: ['AV block'], notes: 'Caution in cats (low dose only).' },
  { id: 'em-6', name: 'Furosemide (Lasix)', category: 'Emergency', concentration: 50, defaultDosage: 2, doseRange: '1-4 mg/kg IV/IM', indications: 'Pulmonary Edema, CHF', sideEffects: 'Dehydration, Hypokalemia', species: 'Both', contraindications: ['Anuria'], notes: 'Diuretic.' },
  { id: 'em-7', name: 'Mannitol 20%', category: 'Emergency', concentration: 200, defaultDosage: 0.5, doseRange: '0.5-1.0 g/kg IV over 20 min', indications: 'Increased ICP, Glaucoma', sideEffects: 'Volume expansion', species: 'Both', contraindications: ['Intracranial bleed (active)', 'Dehydration'], notes: 'Use filter needle (crystals).' },
  { id: 'em-8', name: 'Calcium Gluconate 10%', category: 'Emergency', concentration: 100, defaultDosage: 0.5, doseRange: '0.5-1.5 ml/kg IV slow', indications: 'Hyperkalemia, Hypocalcemia', sideEffects: 'Bradycardia/Arrest if too fast', species: 'Both', contraindications: [], notes: 'Monitor ECG during admin.' },
  { id: 'em-9', name: 'Dextrose 50%', category: 'Emergency', concentration: 500, defaultDosage: 0.5, doseRange: '0.5-1.0 ml/kg IV diluted 1:1', indications: 'Hypoglycemia', sideEffects: 'Phlebitis (if undiluted)', species: 'Both', contraindications: [], notes: 'Dilute to <5% for CRI.' },

  // --- GI / Antiemetics ---
  { id: 'gi-1', name: 'Maropitant (Cerenia)', category: 'Gastrointestinal', concentration: 10, defaultDosage: 1, doseRange: '1 mg/kg IV/SQ q24h', indications: 'Vomiting', sideEffects: 'Pain on injection (SQ)', species: 'Both', contraindications: [], notes: 'Keep refrigerated to reduce sting. Visceral analgesia.' },
  { id: 'gi-2', name: 'Ondansetron', category: 'Gastrointestinal', concentration: 2, defaultDosage: 0.5, doseRange: '0.5-1.0 mg/kg IV/PO q8-12h', indications: 'Nausea, Vomiting', sideEffects: 'Constipation', species: 'Both', contraindications: [], notes: '5-HT3 antagonist.' },
  { id: 'gi-3', name: 'Metoclopramide', category: 'Gastrointestinal', concentration: 5, defaultDosage: 0.3, doseRange: '0.2-0.5 mg/kg PO/SQ/IV q8h', indications: 'Ileus, Vomiting', sideEffects: 'Excitation, Frenzy', species: 'Both', contraindications: ['GI Obstruction'], notes: 'Prokinetic.' },
  { id: 'gi-4', name: 'Pantoprazole', category: 'Gastrointestinal', concentration: 4, defaultDosage: 1, doseRange: '1 mg/kg IV q24h', indications: 'GI Ulceration, Esophagitis', sideEffects: '', species: 'Both', contraindications: [], notes: 'Proton Pump Inhibitor.' },
  { id: 'gi-5', name: 'Famotidine', category: 'Gastrointestinal', concentration: 10, defaultDosage: 0.5, doseRange: '0.5-1.0 mg/kg IV/PO q12h', indications: 'Gastritis', sideEffects: 'Bradycardia (if IV push fast)', species: 'Both', contraindications: [], notes: 'H2 blocker.' },
  { id: 'gi-6', name: 'Sucralfate', category: 'Gastrointestinal', concentration: 0, defaultDosage: 0.5, doseRange: '0.5-1g PO q8h', indications: 'GI Ulcers', sideEffects: 'Constipation', species: 'Both', contraindications: [], notes: 'Give 1hr apart from food/meds.' },
  { id: 'gi-7', name: 'Mirtazapine', category: 'Gastrointestinal', concentration: 0, defaultDosage: 2, doseRange: '1.88 mg/cat PO q48h', indications: 'Appetite stimulant', sideEffects: 'Vocalization, Agitation', species: 'Both', contraindications: ['MAOI'], notes: 'Transdermal often used in cats.' },
  { id: 'gi-8', name: 'Capromorelin (Entyce)', category: 'Gastrointestinal', concentration: 30, defaultDosage: 3, doseRange: '3 mg/kg PO q24h', indications: 'Appetite stimulant', sideEffects: 'Diarrhea', species: 'Canine', contraindications: [], notes: 'Ghrelin agonist.' },

  // --- Steroids ---
  { id: 'st-1', name: 'Dexamethasone SP', category: 'Steroid', concentration: 4, defaultDosage: 0.1, doseRange: '0.1-0.2 mg/kg IV (Anti-inflammatory)', indications: 'Inflammation, Anaphylaxis', sideEffects: 'PU/PD, GI ulcer', species: 'Both', contraindications: ['Infection', 'NSAIDs'], notes: 'Potent. Do not give with NSAIDs.' },
  { id: 'st-2', name: 'Prednisone', category: 'Steroid', concentration: 0, defaultDosage: 0.5, doseRange: '0.5-1 mg/kg PO q24h (Anti-inflam)', indications: 'Inflammation', sideEffects: 'PU/PD, Polyphagia', species: 'Canine', contraindications: ['NSAIDs', 'Cats (poor absorption)'], notes: 'Use Prednisolone for Cats.' },
  { id: 'st-3', name: 'Diphenhydramine', category: 'Antihistamine', concentration: 50, defaultDosage: 2, doseRange: '2 mg/kg IM/PO', indications: 'Allergy, Mast Cell Tumor', sideEffects: 'Sedation', species: 'Both', contraindications: [], notes: 'Benadryl.' }
];

export const MOCK_INPATIENTS: Inpatient[] = [
    {
        id: '1',
        location: 'Mission',
        name: 'Bella',
        signalment: '5y FS Golden',
        diagnosis: 'Septic Abdomen',
        procedure: 'Ex-Lap, R&A',
        pointOfContact: 'Dr. Friesen',
        notes: 'Monitor BP q4h, eating well.'
    },
    {
        id: '2',
        location: 'OP',
        name: 'Max',
        signalment: '2y MN GSD',
        diagnosis: 'Fracture',
        procedure: 'Femoral Plating',
        pointOfContact: 'Dr. Allen',
        notes: 'NWB L HL, pain control w/ Methadone.'
    }
];

export const MOCK_ON_CALL_LOGS: OnCallCaseLog[] = [
    {
        id: 'log-1',
        date: '2025-12-15',
        location: 'MVES',
        patientFirstName: 'Buddy',
        patientLastName: 'Smith',
        caseNumber: '10234',
        referringErDoctor: 'Dr. Johnson',
        attending: 'FRIESEN',
        resident: 'PYNE',
        anesthesiaSupport: 'Jess',
        procedure: 'Gastric Dilatation Volvulus (GDV)',
        payrollCompleted: true
    },
    {
        id: 'log-2',
        date: '2025-12-18',
        location: 'OPVES',
        patientFirstName: 'Luna',
        patientLastName: 'Doe',
        caseNumber: '99231',
        referringErDoctor: 'Dr. Lee',
        attending: 'ALLEN',
        resident: 'PATE',
        anesthesiaSupport: 'Sam',
        procedure: 'Hemoabdomen / Splenectomy',
        payrollCompleted: false
    }
];

export const MOCK_EVENTS: CalendarEvent[] = [
  {
    id: 'evt-2026-10-01-on-call',
    title: 'Surgery Team',
    date: '2026-10-01',
    category: 'on-call',
    onCallTeam: { attending: 'Aeschlimann', resident: 'BULLOCH', anesthesia: 'OPEN' }
  },
  {
    id: 'evt-2026-10-02-on-call',
    title: 'Surgery Team',
    date: '2026-10-02',
    category: 'on-call',
    onCallTeam: { attending: 'Friesen', resident: 'GRISHAM', anesthesia: 'JESS' }
  },
  {
    id: 'evt-2026-10-03-on-call',
    title: 'Surgery Team',
    date: '2026-10-03',
    category: 'on-call',
    onCallTeam: { attending: 'Friesen', resident: 'GRISHAM', anesthesia: 'LUIS' }
  },
  {
    id: 'evt-2026-10-04-on-call',
    title: 'Surgery Team',
    date: '2026-10-04',
    category: 'on-call',
    onCallTeam: { attending: 'Friesen', resident: 'GRISHAM', anesthesia: 'LUIS after 5' }
  },
  {
    id: 'evt-2026-10-05-on-call',
    title: 'Surgery Team',
    date: '2026-10-05',
    category: 'on-call',
    onCallTeam: { attending: 'Friesen', resident: 'BULLOCH', anesthesia: 'LUIS' }
  },
  {
    id: 'evt-2026-10-06-on-call',
    title: 'Surgery Team',
    date: '2026-10-06',
    category: 'on-call',
    onCallTeam: { attending: 'Marquiss', resident: 'BULLOCH', anesthesia: 'LUIS' }
  },
  {
    id: 'evt-2026-10-07-on-call',
    title: 'Surgery Team',
    date: '2026-10-07',
    category: 'on-call',
    onCallTeam: { attending: 'Pyne', resident: 'GRISHAM', anesthesia: 'JESS' }
  },
  {
    id: 'evt-2026-10-08-on-call',
    title: 'Surgery Team',
    date: '2026-10-08',
    category: 'on-call',
    onCallTeam: { attending: 'Aeschlimann', resident: 'GRISHAM', anesthesia: 'OPEN' }
  },
  {
    id: 'evt-2026-10-09-on-call',
    title: 'Surgery Team',
    date: '2026-10-09',
    category: 'on-call',
    onCallTeam: { attending: 'Wilson', resident: 'BULLOCH', anesthesia: 'LUIS' }
  },
  {
    id: 'evt-2026-10-10-on-call',
    title: 'Surgery Team',
    date: '2026-10-10',
    category: 'on-call',
    onCallTeam: { attending: 'Wilson', resident: 'BULLOCH', anesthesia: 'LUIS' }
  },
  {
    id: 'evt-2026-10-11-on-call',
    title: 'Surgery Team',
    date: '2026-10-11',
    category: 'on-call',
    onCallTeam: { attending: 'Wilson', resident: 'BULLOCH', anesthesia: 'ELLEN' }
  },
  {
    id: 'evt-2026-10-12-on-call',
    title: 'Surgery Team',
    date: '2026-10-12',
    category: 'on-call',
    onCallTeam: { attending: 'Marquiss', resident: 'GRISHAM', anesthesia: 'LUIS' }
  },
  {
    id: 'evt-2026-10-13-on-call',
    title: 'Surgery Team',
    date: '2026-10-13',
    category: 'on-call',
    onCallTeam: { attending: 'Pyne', resident: 'GRISHAM', anesthesia: 'ELLEN' }
  },
  {
    id: 'evt-2026-10-14-on-call',
    title: 'Surgery Team',
    date: '2026-10-14',
    category: 'on-call',
    onCallTeam: { attending: 'Wilson', resident: 'BULLOCH', anesthesia: 'JESS' }
  },
  {
    id: 'evt-2026-10-15-on-call',
    title: 'Surgery Team',
    date: '2026-10-15',
    category: 'on-call',
    onCallTeam: { attending: 'Aeschlimann', resident: 'BULLOCH', anesthesia: 'ELLEN' }
  },
  {
    id: 'evt-2026-10-16-on-call',
    title: 'Surgery Team',
    date: '2026-10-16',
    category: 'on-call',
    onCallTeam: { attending: 'Marquiss', resident: 'BALCOM', anesthesia: 'ELLEN' }
  },
  {
    id: 'evt-2026-10-17-on-call',
    title: 'Surgery Team',
    date: '2026-10-17',
    category: 'on-call',
    onCallTeam: { attending: 'Marquiss', resident: 'BALCOM', anesthesia: 'LUIS' }
  },
  {
    id: 'evt-2026-10-18-on-call',
    title: 'Surgery Team',
    date: '2026-10-18',
    category: 'on-call',
    onCallTeam: { attending: 'Marquiss', resident: 'BALCOM', anesthesia: 'LUIS after 5' }
  },
  {
    id: 'evt-2026-10-19-on-call',
    title: 'Surgery Team',
    date: '2026-10-19',
    category: 'on-call',
    onCallTeam: { attending: 'Friesen', resident: 'BULLOCH', anesthesia: 'JESS' }
  },
  {
    id: 'evt-2026-10-20-on-call',
    title: 'Surgery Team',
    date: '2026-10-20',
    category: 'on-call',
    onCallTeam: { attending: 'Marquiss', resident: 'BULLOCH', anesthesia: 'JESS' }
  },
  {
    id: 'evt-2026-10-21-on-call',
    title: 'Surgery Team',
    date: '2026-10-21',
    category: 'on-call',
    onCallTeam: { attending: 'Wilson', resident: 'BALCOM', anesthesia: 'ELLEN' }
  },
  {
    id: 'evt-2026-10-22-on-call',
    title: 'Surgery Team',
    date: '2026-10-22',
    category: 'on-call',
    onCallTeam: { attending: 'Pyne', resident: 'BALCOM', anesthesia: 'ELLEN' }
  },
  {
    id: 'evt-2026-10-23-on-call',
    title: 'Surgery Team',
    date: '2026-10-23',
    category: 'on-call',
    onCallTeam: { attending: 'Aeschlimann', resident: 'PATE', anesthesia: 'LUIS' }
  },
  {
    id: 'evt-2026-10-24-on-call',
    title: 'Surgery Team',
    date: '2026-10-24',
    category: 'on-call',
    onCallTeam: { attending: 'Aeschlimann', resident: 'PATE', anesthesia: 'ELLEN after 12' }
  },
  {
    id: 'evt-2026-10-25-on-call',
    title: 'Surgery Team',
    date: '2026-10-25',
    category: 'on-call',
    onCallTeam: { attending: 'Aeschlimann', resident: 'PATE', anesthesia: 'ELLEN' }
  },
  {
    id: 'evt-2026-10-26-on-call',
    title: 'Surgery Team',
    date: '2026-10-26',
    category: 'on-call',
    onCallTeam: { attending: 'Friesen', resident: 'BULLOCH', anesthesia: 'OPEN' }
  },
  {
    id: 'evt-2026-10-27-on-call',
    title: 'Surgery Team',
    date: '2026-10-27',
    category: 'on-call',
    onCallTeam: { attending: 'Marquiss', resident: 'BULLOCH', anesthesia: 'ELLEN' }
  },
  {
    id: 'evt-2026-10-28-on-call',
    title: 'Surgery Team',
    date: '2026-10-28',
    category: 'on-call',
    onCallTeam: { attending: 'Wilson', resident: 'PATE', anesthesia: 'ELLEN' }
  },
  {
    id: 'evt-2026-10-29-on-call',
    title: 'Surgery Team',
    date: '2026-10-29',
    category: 'on-call',
    onCallTeam: { attending: 'Pyne', resident: 'PATE', anesthesia: 'LUIS' }
  },
  {
    id: 'evt-2026-10-30-on-call',
    title: 'Surgery Team',
    date: '2026-10-30',
    category: 'on-call',
    onCallTeam: { attending: 'Aeschlimann', resident: 'BALCOM', anesthesia: 'Yuri' }
  },
  {
    id: 'evt-2026-10-31-on-call',
    title: 'Surgery Team',
    date: '2026-10-31',
    category: 'on-call',
    onCallTeam: { attending: 'Aeschlimann', resident: 'BALCOM', anesthesia: 'OPEN' }
  },
  {
    id: 'evt-2026-11-01-on-call',
    title: 'Surgery Team',
    date: '2026-11-01',
    category: 'on-call',
    onCallTeam: { attending: 'Friesen', resident: 'BALCOM', anesthesia: 'ELLEN after 12' }
  },
  {
    id: 'evt-2026-11-02-on-call',
    title: 'Surgery Team',
    date: '2026-11-02',
    category: 'on-call',
    onCallTeam: { attending: 'Friesen', resident: 'GRISHAM', anesthesia: 'Jess' }
  },
  {
    id: 'evt-2026-11-03-on-call',
    title: 'Surgery Team',
    date: '2026-11-03',
    category: 'on-call',
    onCallTeam: { attending: 'Marquiss', resident: 'GRISHAM', anesthesia: 'Jess' }
  },
  {
    id: 'evt-2026-11-04-on-call',
    title: 'Surgery Team',
    date: '2026-11-04',
    category: 'on-call',
    onCallTeam: { attending: 'Pyne', resident: 'BALCOM', anesthesia: 'Jess' }
  },
  {
    id: 'evt-2026-11-05-on-call',
    title: 'Surgery Team',
    date: '2026-11-05',
    category: 'on-call',
    onCallTeam: { attending: 'Friesen', resident: 'BALCOM', anesthesia: 'LUIS' }
  },
  {
    id: 'evt-2026-11-06-on-call',
    title: 'Surgery Team',
    date: '2026-11-06',
    category: 'on-call',
    onCallTeam: { attending: 'Friesen', resident: 'GRISHAM', anesthesia: 'ELLEN/JORDAN' }
  },
  {
    id: 'evt-2026-11-07-on-call',
    title: 'Surgery Team',
    date: '2026-11-07',
    category: 'on-call',
    onCallTeam: { attending: 'Friesen', resident: 'GRISHAM', anesthesia: 'LUIS' }
  },
  {
    id: 'evt-2026-11-08-on-call',
    title: 'Surgery Team',
    date: '2026-11-08',
    category: 'on-call',
    onCallTeam: { attending: 'Friesen', resident: 'GRISHAM', anesthesia: 'ELLEN/JORDAN' }
  },
  {
    id: 'evt-2026-11-09-on-call',
    title: 'Surgery Team',
    date: '2026-11-09',
    category: 'on-call',
    onCallTeam: { attending: 'Friesen', resident: 'PATE', anesthesia: 'ELLEN/JORDAN' }
  },
  {
    id: 'evt-2026-11-10-on-call',
    title: 'Surgery Team',
    date: '2026-11-10',
    category: 'on-call',
    onCallTeam: { attending: 'Pyne', resident: 'PATE', anesthesia: 'ELLEN' }
  },
  {
    id: 'evt-2026-11-11-on-call',
    title: 'Surgery Team',
    date: '2026-11-11',
    category: 'on-call',
    onCallTeam: { attending: 'Wilson', resident: 'GRISHAM', anesthesia: 'ELLEN/JORDAN' }
  },
  {
    id: 'evt-2026-11-12-on-call',
    title: 'Surgery Team',
    date: '2026-11-12',
    category: 'on-call',
    onCallTeam: { attending: 'Aeschlimann', resident: 'GRISHAM', anesthesia: 'LUIS' }
  },
  {
    id: 'evt-2026-11-13-on-call',
    title: 'Surgery Team',
    date: '2026-11-13',
    category: 'on-call',
    onCallTeam: { attending: 'Marquiss', resident: 'BALCOM', anesthesia: 'ELLEN' }
  },
  {
    id: 'evt-2026-11-14-on-call',
    title: 'Surgery Team',
    date: '2026-11-14',
    category: 'on-call',
    onCallTeam: { attending: 'Marquiss', resident: 'BALCOM', anesthesia: 'ELLEN after 12 / Hailey AM' }
  },
  {
    id: 'evt-2026-11-15-on-call',
    title: 'Surgery Team',
    date: '2026-11-15',
    category: 'on-call',
    onCallTeam: { attending: 'Marquiss', resident: 'BALCOM', anesthesia: 'ELLEN' }
  },
  {
    id: 'evt-2026-11-16-on-call',
    title: 'Surgery Team',
    date: '2026-11-16',
    category: 'on-call',
    onCallTeam: { attending: 'Friesen', resident: 'GRISHAM', anesthesia: 'Jess' }
  },
  {
    id: 'evt-2026-11-17-on-call',
    title: 'Surgery Team',
    date: '2026-11-17',
    category: 'on-call',
    onCallTeam: { attending: 'Marquiss', resident: 'GRISHAM', anesthesia: 'Jess' }
  },
  {
    id: 'evt-2026-11-18-on-call',
    title: 'Surgery Team',
    date: '2026-11-18',
    category: 'on-call',
    onCallTeam: { attending: 'Wilson', resident: 'BULLOCH', anesthesia: 'Jess' }
  },
  {
    id: 'evt-2026-11-19-on-call',
    title: 'Surgery Team',
    date: '2026-11-19',
    category: 'on-call',
    onCallTeam: { attending: 'Pyne', resident: 'BULLOCH', anesthesia: 'LUIS' }
  },
  {
    id: 'evt-2026-11-20-on-call',
    title: 'Surgery Team',
    date: '2026-11-20',
    category: 'on-call',
    onCallTeam: { attending: 'Wilson', resident: 'PATE', anesthesia: 'LUIS' }
  },
  {
    id: 'evt-2026-11-21-on-call',
    title: 'Surgery Team',
    date: '2026-11-21',
    category: 'on-call',
    onCallTeam: { attending: 'Wilson', resident: 'PATE', anesthesia: 'LUIS' }
  },
  {
    id: 'evt-2026-11-22-on-call',
    title: 'Surgery Team',
    date: '2026-11-22',
    category: 'on-call',
    onCallTeam: { attending: 'Wilson', resident: 'PATE', anesthesia: 'ELLEN' }
  },
  {
    id: 'evt-2026-11-23-on-call',
    title: 'Surgery Team',
    date: '2026-11-23',
    category: 'on-call',
    onCallTeam: { attending: 'Friesen', resident: 'BULLOCH', anesthesia: 'LUIS' }
  },
  {
    id: 'evt-2026-11-24-on-call',
    title: 'Surgery Team',
    date: '2026-11-24',
    category: 'on-call',
    onCallTeam: { attending: 'Marquiss', resident: 'BULLOCH', anesthesia: 'LUIS' }
  },
  {
    id: 'evt-2026-11-25-on-call',
    title: 'Surgery Team',
    date: '2026-11-25',
    category: 'on-call',
    onCallTeam: { attending: 'Friesen', resident: 'GRISHAM', anesthesia: 'ELLEN' }
  },
  {
    id: 'evt-2026-11-26-on-call',
    title: 'Surgery Team',
    date: '2026-11-26',
    category: 'on-call',
    onCallTeam: { attending: 'Friesen', resident: 'GRISHAM', anesthesia: 'ELLEN' }
  },
  {
    id: 'evt-2026-11-27-on-call',
    title: 'Surgery Team',
    date: '2026-11-27',
    category: 'on-call',
    onCallTeam: { attending: 'Friesen', resident: 'BULLOCH', anesthesia: 'LUIS' }
  },
  {
    id: 'evt-2026-11-28-on-call',
    title: 'Surgery Team',
    date: '2026-11-28',
    category: 'on-call',
    onCallTeam: { attending: 'Friesen', resident: 'BULLOCH', anesthesia: 'LUIS' }
  },
  {
    id: 'evt-2026-11-29-on-call',
    title: 'Surgery Team',
    date: '2026-11-29',
    category: 'on-call',
    onCallTeam: { attending: 'Friesen', resident: 'BULLOCH', anesthesia: 'Hailey AM / LUIS after 6' }
  },
  {
    id: 'evt-2026-11-30-on-call',
    title: 'Surgery Team',
    date: '2026-11-30',
    category: 'on-call',
    onCallTeam: { attending: 'Pyne', resident: 'PATE', anesthesia: 'LUIS' }
  }
];

export const MOCK_LABS: LabEntry[] = [
    {
        id: '1',
        patientName: 'Luna',
        sampleType: 'Histopathology',
        hospital: 'Mission',
        submissionDate: '2025-12-01',
        submittedTo: 'Antech',
        status: 'pending',
        notes: 'Osteosarcoma suspected',
        attending: 'FRIESEN',
        resident: 'PYNE'
    },
    {
        id: '2',
        patientName: 'Thor',
        sampleType: 'Joint Fluid Analysis',
        hospital: 'OP',
        submissionDate: '2025-12-05',
        submittedTo: 'Idexx',
        status: 'received',
        notes: 'Septic arthritis confirmed',
        attending: 'ALLEN',
        resident: 'GRISHAM'
    }
];

export const EDUCATION_EVENTS: EducationEvent[] = [
    {
        id: 'edu-1',
        date: '2025-12-03',
        time: '07:00 AM',
        title: 'Journal Club: Soft Tissue',
        presenter: 'Surgical Residents',
        type: 'Journal Club',
        articles: [
            { id: 'a1', title: 'SAS Outcomes', fileName: 'sas_study_2024.pdf', uploadDate: '2025-11-28', size: '1.2 MB', assignedResidentId: '6' } 
        ]
    },
    {
        id: 'edu-2',
        date: '2025-12-10',
        time: '07:00 AM',
        title: 'Morbidity & Mortality Rounds',
        presenter: 'All Residents',
        type: 'Morbidity & Mortality',
        articles: []
    }
];

export const CASE_LOG_DATA = {
    settings: {
        Surgeon: ['AESCHLIMANN', 'ALLEN', 'WILSON', 'FRIESEN', 'MARQUISS', 'WEINSTEIN'],
        Residents: ['PYNE', 'PATE', 'GRISHAM', 'BALCOM'],
        "Column 1": [],
        "Surgical Procedure": [],
        "Surgical Category": [],
        "Core Curriculum": []
    },
    logs: {
        "Log-MVES": [],
        "Log-OPVES": [],
        "Summary": [] 
    }
};
